import {
  AutocompleteInput,
  Datagrid,
  DateField,
  EditButton,
  List,
  ReferenceField,
  ReferenceInput,
  SelectField,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { settings } from "app";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { MobileListRow } from "features/MobileListRow";
import { formatDateOnlyBg } from "server/formatting/formatDateBg";
import { administrationRequests } from "api/administrationApi";
import { SemestersChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";

const ListCurriculumSelectionCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Избор на учебен план"
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на кампанията", value: record?.name }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialityId"
                        reference={administrationRequests.getSpecialitiesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Семестър",
                    value: (
                      <SelectField
                        source="semester"
                        choices={SemestersChoices}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Кандидатстване",
                    value: `${formatDateOnlyBg(record?.applicationStartDate)} - ${formatDateOnlyBg(record?.applicationEndDate)}`,
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageCurriculumSelectionCampaigns}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="name"
            label="Име на кампанията"
            sortable={false}
          />
          <ReferenceField
            source="specialityId"
            reference={administrationRequests.getSpecialitiesSelect()}
            label="Специалност"
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <SelectField
            source="semester"
            label="Семестър"
            choices={SemestersChoices}
            sortable={false}
          />
          <DateField
            source="applicationStartDate"
            label="Начало на кандидатстването"
            locales="bg-BG"
            sortable={false}
          />
          <DateField
            source="applicationEndDate"
            label="Край на кандидатстването"
            locales="bg-BG"
            sortable={false}
          />
          <SecuredComponent permission={permissions.canManageCurriculumSelectionCampaigns}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListCurriculumSelectionCampaigns;
